// This regular expression is a more refined version of the first one.
// It matches <script> tags with any attributes (e.g., <script type="text/javascript">),
// and captures everything between the opening and closing <script> tags.
// It uses a non-greedy match for the content inside the <script> tags to ensure that it captures
// the content of each individual <script> block without matching beyond the first closing </script> tag.

const sanitizeRegExp = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;

const sanitizeHTML = (HTML = '') => HTML.replace(sanitizeRegExp, '');

export default sanitizeHTML;
